export default {
  transition: 250,
  breakpoints: {
    small: {
      label: 'small',
      lowerbound: 325,
      upperbound: 831
    },
    medium: {
      label: 'medium',
      lowerbound: 832,
      upperbound: 1023
    },
    large: {
      label: 'large',
      lowerbound: 1024,
      upperbound: 2100
    }
  },
  headerHeight: {
    mobile: 80,
    desktop: 92
  },
  locationsCardsWidth: 532,
  alertHeight: {
    mobile: 36,
    desktop: 40
  }
};



// WEBPACK FOOTER //
// ./src/constants/Global.js